import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
// import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../../styles/payment-link/payment-link.css";
import PaymentLinkStructure from "../../components/payment-link-system/PaymentLinkStructure";
import PaymentLinkFilters from "../../components/payment-link-system/PaymentLinkFilters";
import OnlineCashTabs from "../../components/payment-link-system/OnlineCashTabs";
import {
  fetchAllCashPaymentLinksData,
  fetchAllOnlinePaymentLinksData,
} from "../../redux/reducers/apiSlice";
import { fetchPaymentLinkHomeStatData } from "../../redux/plans-reducers/plansSlice";
import { selectAuth } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";

const PaymentLink = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});

  const {
    allOnlinePaymentLinkDataLoading,
    allCashPaymentDataLoading,
    allOnlinePaymentLinkData,
    allCashPaymentData,
  } = useSelector((state) => state.api);
  const {
    paymentLinkHomeStat,
    paymentLinkHomeStatLoading,
    paymentLinkHomeStatError,
  } = useSelector((state) => state.plans);

  const isAdmin = decryptedText?.account_type === "admin";
  const isGym = decryptedText?.account_type === "gym";
  const isClusterManager = decryptedText?.account_type === "cluster_manager";

  // Check if user is a manager role (cluster_manager, fitness_manager, sales_manager, club_manager)
  const isManagerRole = ["cluster_manager", "fitness_manager", "sales_manager", "club_manager"].includes(decryptedText?.account_type);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const initialPaymentData = {
    onlinePaymentData: [],
    cashPaymentData: [],
    // onlineIsPage: 0,
    // cashIsPage: 0,
    onlinePagination: [],
    cashPagination: [],
    allOnlineAmount: {},
    allCashAmount: {},
  };
  const [allPaymentData, setAllPaymentData] = useState(initialPaymentData);
  const iniAllFilters = {
    searchString: "",
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? decryptedText?.name : decryptedText?.gym_name || "",
          value:
            decryptedText?.gym_id ||
            decryptedText?.uid ||
            decryptedText?.user_id ||
            "",
        }
      : "",
    selectedPaymentType: "",
    selectedStatus: "",
    selectedApprovalStatus: "",
    selectedCreator: "",
    selectedSubsType: "",
    selectedPlan: "",
    selPaymentSource: "",
    selectedStartDate: "",
    selectedEndDate: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit,
    gym_id: allFilters.selectedGym?.value || "",
    added_by_id: allFilters.selectedCreator?.value || "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    is_partial: allFilters.selectedPaymentType?.value || "",
    type: allFilters.selectedSubsType?.value || "",
    duration: allFilters.selectedPlan?.value || "",
    payment_through: allFilters.selPaymentSource?.value || "",
    status: allFilters.selectedStatus?.value || "",
    is_approved: allFilters.selectedApprovalStatus?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
  };

  function getOnlinePMLinks(filters = {}) {
    const { is_approved, ...rest } = filters;

    dispatch(
      fetchAllOnlinePaymentLinksData({
        filters: rest,
        token: decryptedText?.token,
      })
    );
  }

  function getCashPMLink(filters = {}) {
    const { status, ...rest } = filters;

    dispatch(
      fetchAllCashPaymentLinksData({
        filters: rest,
        token: decryptedText?.token,
      })
    );
  }

  function getPaymentLinkHomeStat(filters = {}) {
    const { is_approved, ...rest } = filters;

    dispatch(
      fetchPaymentLinkHomeStatData({
        filters: rest,
        token: decryptedText?.token,
      })
    );
  }

  function getCombinedCall() {
    getOnlinePMLinks(filters);
    getCashPMLink(filters);
    getPaymentLinkHomeStat(filters);
  }

  useEffect(() => {
    getOnlinePMLinks(filters);
    getPaymentLinkHomeStat(filters);
  }, [
    filters.page,
    filters.limit,
    filters.gym_id,
    filters.status,
    filters.added_by_id,
    filters.start_date,
    filters.end_date,
    filters.is_partial,
    filters.type,
    filters.duration,
    filters.payment_through,
    filters.search,
  ]);

  useEffect(() => {
    getCashPMLink(filters);
  }, [
    filters.page,
    filters.limit,
    filters.gym_id,
    filters.is_approved,
    filters.added_by_id,
    filters.start_date,
    filters.end_date,
    filters.is_partial,
    filters.type,
    filters.duration,
    filters.payment_through,
    filters.search,
  ]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin
  //       ? {
  //           label: isGym ? decryptedText?.name : decryptedText?.gym_name || "",
  //           value:
  //             decryptedText?.gym_id ||
  //             decryptedText?.uid ||
  //             decryptedText?.user_id ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [decryptedText?.gym_id]);

  useEffect(() => {
    setFilters({
      page: isPage + 1,
      limit: pageLimit,
      gym_id: allFilters.selectedGym?.value || "",
      added_by_id: allFilters.selectedCreator?.value || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      is_partial: allFilters.selectedPaymentType?.value || "",
      type: allFilters.selectedSubsType?.value || "",
      duration: allFilters.selectedPlan?.value || "",
      payment_through: allFilters.selPaymentSource?.value || "",
      status: allFilters.selectedStatus?.value || "",
      is_approved: allFilters.selectedApprovalStatus?.value || "",
    });
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedStatus,
    allFilters.selectedCreator,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    allFilters.selectedPaymentType,
    allFilters.selectedSubsType,
    allFilters.selectedPlan,
    allFilters.selPaymentSource,
    allFilters.selectedApprovalStatus,
  ]);

  useEffect(() => {
    if (
      allOnlinePaymentLinkData?.status &&
      allOnlinePaymentLinkData?.data?.length > 0
    ) {
      setAllPaymentData((prevData) => ({
        ...prevData,
        onlinePaymentData: allOnlinePaymentLinkData.data || [],
        onlinePagination: allOnlinePaymentLinkData.pagination || [],
      }));
    } else {
      setAllPaymentData((prevData) => ({
        ...prevData,
        onlinePaymentData: [],
        onlinePagination: [],
      }));
    }
  }, [allOnlinePaymentLinkData]);

  useEffect(() => {
    if (paymentLinkHomeStat?.status && paymentLinkHomeStat?.data) {
      setAllPaymentData((prevData) => ({
        ...prevData,
        allOnlineAmount: paymentLinkHomeStat.data,
      }));
    } else {
      setAllPaymentData((prevData) => ({
        ...prevData,
        allOnlineAmount: {},
      }));
    }
  }, [
    paymentLinkHomeStat,
    paymentLinkHomeStatLoading,
    paymentLinkHomeStatError,
  ]);

  useEffect(() => {
    if (allCashPaymentData?.status && allCashPaymentData?.data?.length > 0) {
      const { status, data, pagination, ...rest } = allCashPaymentData || {};

      setAllPaymentData({
        ...allPaymentData,
        cashPaymentData: allCashPaymentData.data || [],
        cashPagination: allCashPaymentData?.pagination || [],
        allCashAmount: { ...rest },
      });
    } else {
      setAllPaymentData({
        ...allPaymentData,
        cashPaymentData: [],
        cashPagination: [],
        allCashAmount: {},
      });
    }
  }, [allCashPaymentData]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <HelmetWrapper title="WTF: One Time Payment Link System">
      <Container className="bg-cloud-k px-50px" fluid>
        {/* <Tabs>
          <TabList>
            <Tab>One Time Payment Link</Tab>
            <Tab>Agreement Logs</Tab>
          </TabList>

          <TabPanel> */}
        <Row>
          <Col>
            <PaymentLinkStructure
              onClickReset={onClickReset}
              callFunction={getCombinedCall}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <PaymentLinkFilters
              decryptedText={decryptedText}
              allPaymentOnlineData={allPaymentData.allOnlineAmount}
              allPaymentCashData={allPaymentData.allCashAmount}
              paymentTableFilters={allFilters}
              setPaymentFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              onClickReset={onClickReset}
              isLoading={
                allOnlinePaymentLinkDataLoading || allCashPaymentDataLoading
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <OnlineCashTabs
              userInfoData={decryptedText}
              allPaymentData={allPaymentData}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </Col>
        </Row>
        {/* </TabPanel>

          <TabPanel>
            <AgreementsReport />
          </TabPanel>
        </Tabs> */}
      </Container>
    </HelmetWrapper>
  );
};

export default PaymentLink;
